export default [
  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "auth" */ "./Login.vue"),
    meta: { sidebar: false, topbar: false },
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import(/* webpackChunkName: "auth" */ "./Logout.vue"),
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () =>
      import(/* webpackChunkName: "auth" */ "./ForgotPassword.vue"),
    meta: { sidebar: false, topbar: false },
  },
];
